import { TimeRange } from "../models/common";

export const revivePersistedDate = (
    persistedDate?: Date | string
): Date | undefined => {
    if (!persistedDate) {
        return undefined;
    }

    const revivedDate =
        persistedDate instanceof Date ? persistedDate : new Date(persistedDate);

    return Number.isNaN(revivedDate.getTime()) ? undefined : revivedDate;
};

export const revivePersistedReportingSelection = (
    reportingSelectedRange: TimeRange,
    reportingstartDate: Date | string | undefined,
    reportingEndDate: Date | string | undefined,
    fallbackRange: TimeRange
) => {
    const revivedStartDate = revivePersistedDate(reportingstartDate);
    const revivedEndDate = revivePersistedDate(reportingEndDate);
    const shouldFallbackToDefaultRange =
        reportingSelectedRange === TimeRange.Custom &&
        (!revivedStartDate || !revivedEndDate);

    return {
        reportingSelectedRange: shouldFallbackToDefaultRange
            ? fallbackRange
            : reportingSelectedRange,
        reportingstartDate: shouldFallbackToDefaultRange
            ? undefined
            : revivedStartDate,
        reportingEndDate: shouldFallbackToDefaultRange
            ? undefined
            : revivedEndDate,
    };
};
